import React from 'react';

import styles from '../onboardingFormStyles.scss';

class OnboardingTickerSuggestionCard extends React.Component {
  constructor() {
    super();
    this.state = { loading: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    if (this.state.loading) return;
    const { followEntity, entityId } = this.props;
    this.setState({ loading: true });
    followEntity({ variables: { entityId, skipSideEffects: true } });
  }

  render() {
    const { primarySymbol, name } = this.props;
    const { loading } = this.state;
    return (
      <div className={styles.cardContainer}>
        {loading && <div className={styles.loadingCard} />}
        <div className={styles.tickerCard} onClick={this.handleClick} id="ticker-card">
          <strong>{primarySymbol}</strong> - {name}
        </div>
      </div>
    );
  }
}

export default OnboardingTickerSuggestionCard;
